import { render, staticRenderFns } from "./InvestmentsMaturity.vue?vue&type=template&id=94ece556&scoped=true"
import script from "./InvestmentsMaturity.vue?vue&type=script&lang=js"
export * from "./InvestmentsMaturity.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsMaturity.vue?vue&type=style&index=0&id=94ece556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ece556",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLazy,VSpacer})
